import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createButtonBlock,
  createH2Block,
  createPBlock,
  createUlBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBorderRadiusOptions } from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { getColorOptions } from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import checkBulletImage from "../../Content/UlListBlock/check_bullet.png";
import { getSalesBlockTertiaryStyleOptions } from "../constants";
import imagePlaceholder from "./sales_block_8_image_placeholder.png";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "SalesBlock8",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Featured Case study: from Burnout to Balance",
          styles: {
            color: getColorOptions(
              "var(--theme-website-primary-button-default-text-color)",
            ),
          },
        }),
      ],
    },
    leftContent: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: imagePlaceholder,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                width: "100%",
                height: "100%",
                maxHeight: "none",
                maxWidth: "none",
                minHeight: "auto",
                minWidth: "auto",
              },
            }),
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 20,
                border_left_bottom_radius: 20,
                border_right_top_radius: 20,
                border_right_bottom_radius: 20,
              },
            }),
          },
        }),
      ],
    },
    rightContent: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "Watch how Jennifer transformed her approach to leadership and reclaimed 15+ hours per week while increasing her team's productivity by 35%",
          paragraphStyle: "p1",
        }),
        createPBlock({
          text: "In this in-depth case study, you'll discover the exact strategies Jennifer used to:",
          paragraphStyle: "p3",
        }),
        createUlBlock({
          items: [
            {
              text: "Restructure her workday for maximum productivity",
              placeholder: checkBulletImage,
            },
            {
              text: "Delegate effectively without losing control",
              placeholder: checkBulletImage,
            },
            {
              text: "Implement systems that run without her constant input",
              placeholder: checkBulletImage,
            },
            {
              text: "Create boundaries that protect her energy and focus",
              placeholder: checkBulletImage,
            },
          ],
        }),
      ],
    },
    buttons: {
      prop: "children",
      type: "children",
      value: [
        createButtonBlock({
          text: "Watch Case Study",
          href: "#",
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getSalesBlockTertiaryStyleOptions(),
      },
    },
  },
};
